export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10664.1deee174.jpg";